import { SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DoCheck, input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

interface FormErrorMessages {
  [key: string]: string;
}

@Component({
  selector: 'ish-form-control-feedback',
  templateUrl: './form-control-feedback.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [FaIconComponent, SlicePipe, TranslateModule],
})
export class FormControlFeedbackComponent implements DoCheck {
  readonly control = input.required<AbstractControl>();
  readonly messages = input<FormErrorMessages>({});

  errors: string[];

  ngDoCheck() {
    if (this.control().dirty) {
      this.errors = this.getErrorList();
    }
  }

  private getErrorList(): string[] {
    if (!this.control().errors) {
      return [];
    }

    return Object.keys(this.control().errors)
      .map(key =>
        this.messages() && key in this.messages && this.messages()[key]
          ? this.messages()[key]
          : this.control().errors.customError
      )
      .filter(locString => !!locString);
  }
}
